module.exports = __webpack_public_path__ + "static/media/cloud-download-outline.d4bb8980.svg";